import { useTranslation } from 'react-i18next';
import { useCurrentUser } from 'pos-client/hooks/useCurrentUser.ts';
import { useLocations } from 'pos-client/hooks/useLocations.tsx';
import { useNotifications } from 'pos-client/hooks/useNotifications.tsx';
import type { LocationModel } from 'pos-shared/models/locationSchema.ts';

export interface UseUserAssignedLocationsProps {
  setShowNoLocationAlert?: (x: boolean) => void;
  handleLocationSelectChange?: (
    selectedServiceLocationId: string,
    data: LocationModel[]
  ) => void;
}
export const useUserAssignedLocations = ({
  setShowNoLocationAlert,
  handleLocationSelectChange,
}: UseUserAssignedLocationsProps = {}) => {
  const { t } = useTranslation();

  const { currentUser } = useCurrentUser();

  const { showError } = useNotifications();

  const {
    locationSearchResponse,
    locations,
    locationOptions,
    isLoadingLocations,
  } = useLocations(
    {
      assignedUserId: currentUser?.id,
    },
    {
      enabled: !!currentUser,
      onSuccess: async (data) => {
        if (data?.results?.length === 0 && setShowNoLocationAlert) {
          setShowNoLocationAlert(true);
        }
        if (data?.results?.length === 1 && handleLocationSelectChange) {
          handleLocationSelectChange(data.results[0].id, data.results);
        }
      },
      onError: () => {
        showError(
          t('common.notification.error.message', {
            action: 'load',
            entity: 'service locations',
          })
        );
      },
    }
  );

  return {
    locationSearchResponse,
    locations,
    locationOptions,
    isLoadingLocations,
  };
};
